import Api from '@/services/Api'
import axios from 'axios'

export default {
  
  addAptitudeWork (params) {
    return Api().post("/aptitude-works",params);
  },
  findByCovidPatientId (params) {
    return Api().get("/findByCovidPatientId/"+params);
  }
  
}



// WEBPACK FOOTER //
// ./src/services/AptitudeWorkService.js